import 'zone.js/dist/zone';
import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
 

declare var webkitSpeechRecognition;

@Component({
  selector: 'app-speech-to-text',
  templateUrl: './speech-to-text.component.html',
  styleUrls: ['./speech-to-text.component.scss']
})
export class SpeechToTextComponent implements OnDestroy {
  @Output('SpeechToText') SpeechToText = new EventEmitter()
  micOn:boolean = true
  results:any = ''
  vSearch:any
  constructor(){
    this.vSearch = new webkitSpeechRecognition();
    this.vSearch.continuous = true;
    this.vSearch.interimresults = false;
    this.vSearch.lang = 'en-US';
  }

  ngOnInit(): void {
    this.vSearch.onresult = (e) => {
 
      // voiceHandler.value = e?.results[0][0]?.transcript;
      this.results += ' '+ e?.results[e.results.length - 1][0]?.transcript; ;
      this.getResult();
    
     
    };

  }

  ngOnDestroy(): void {
    this.stopListening()
  }
 
  startListening() {
    // let voiceHandler = this.hiddenSearchHandler?.nativeElement;
    if ('webkitSpeechRecognition' in window) {
      this.micOn = false
      this.vSearch.start();
    } else {
      alert('Your browser does not support voice recognition!');
    }
  }

  stopListening(){
    this.vSearch.stop();
    this.micOn = true
    this.results = ''
  }

  getResult(){
    this.SpeechToText.emit(this.results)
  }

}
